import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
interface LanguageSelectorProps {
  selected: 'bn' | 'en';
  onSelect: (lang: 'bn' | 'en') => void;
}
export function LanguageSelector({
  selected,
  onSelect
}: LanguageSelectorProps) {
  return <div className="space-y-4 w-full" data-id="element-29">
      <button onClick={() => onSelect('bn')} className={`w-full p-4 rounded-xl border-2 flex items-center justify-between transition-all ${selected === 'bn' ? 'border-[#006a4e] bg-[#006a4e]/5 text-[#006a4e]' : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'}`} data-id="element-30">
        <div className="flex items-center space-x-4" data-id="element-31">
          <span className="text-3xl" data-id="element-32">🇧🇩</span>
          <div className="text-left" data-id="element-33">
            <p className="font-bold text-lg font-bengali" data-id="element-34">বাংলা</p>
            <p className="text-sm opacity-75" data-id="element-35">Bengali</p>
          </div>
        </div>
        {selected === 'bn' && <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} data-id="element-36">
            <div className="bg-[#006a4e] text-white rounded-full p-1" data-id="element-37">
              <Check size={16} data-id="element-38" />
            </div>
          </motion.div>}
      </button>

      <button onClick={() => onSelect('en')} className={`w-full p-4 rounded-xl border-2 flex items-center justify-between transition-all ${selected === 'en' ? 'border-[#006a4e] bg-[#006a4e]/5 text-[#006a4e]' : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'}`} data-id="element-39">
        <div className="flex items-center space-x-4" data-id="element-40">
          <span className="text-3xl" data-id="element-41">🇺🇸</span>
          <div className="text-left" data-id="element-42">
            <p className="font-bold text-lg" data-id="element-43">English</p>
            <p className="text-sm opacity-75 font-bengali" data-id="element-44">ইংরেজি</p>
          </div>
        </div>
        {selected === 'en' && <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} data-id="element-45">
            <div className="bg-[#006a4e] text-white rounded-full p-1" data-id="element-46">
              <Check size={16} data-id="element-47" />
            </div>
          </motion.div>}
      </button>
    </div>;
}